// import external dependencies
import 'jquery';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'slick-carousel/slick/slick.min';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,

  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Detect and Remove Date Picker Autofill
$('.gfield .datepicker').each(function () {
  $(this).attr('autocomplete', 'off');
});


var whiteHeader = $('.white-header');
// var screenWidth = $(window).width();
var scrollPosition = $(window).scrollTop();

function addingColorHover() {
  whiteHeader.mouseenter(function () {
    $(this).addClass('colored');
  });
  whiteHeader.mouseleave(function () {
    var scrollPosition = $(window).scrollTop();
    if (scrollPosition <= 49) {
      $(this).removeClass('colored');
    }
  });
}


$(document).ready(function () {
  if (scrollPosition <= 49) {
    addingColorHover();
  }

  if (scrollPosition > 50) {
    whiteHeader.addClass('colored');
  }
});

$(window).on('scroll', function () {
  var scrollPosition = $(window).scrollTop();
  if (scrollPosition > 50) {
    whiteHeader.addClass('colored');
  }
  if (scrollPosition > 50) {
    whiteHeader.addClass('colored');
  }
  if (scrollPosition <= 49) {
    whiteHeader.removeClass('colored');
    addingColorHover();
  }
});



// WEBPACK FOOTER //
// ./scripts/main.js